import React, { useRef } from 'react';
import { Box, Button, CircularProgress, FormGroup, IconButton, Typography } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon, PictureAsPdf as DocumentIcon, InsertDriveFile } from '@mui/icons-material';
import { useField } from 'formik';
import { uploadFileRequest } from '../../services/file_upload';
import { toast } from 'react-toastify';
import { userUploadFileRequest } from '../../services/user';

const boxStyles = {
    width: '100%',
    height: 200,
    mb: 2,
    mt: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'secondary',
    border: '1px solid #eaeaea',
    borderRadius: 3,
    cursor: 'pointer'
};

function SingleFileUploadField({ noValidation = false, label, fileType = 'image', fileIcon, ...props }) {
    const [{ value, ...field }, meta, helpers] = useField(props);

    const fileInputRef = useRef();

    const handleChange = async (event) => {
        const files = Array.from(event.target.files);
        // debugger;
        const [file] = files;
        if (!file.type.includes(fileType)) {
            toast.error(`Only ${fileType === 'application' ? 'pdf, .xls, .xlsx' : fileType} files are allowed`);
            return;
        }

        console.log(file.size / 1024, file.size / 1024 / 1024);

        if (!noValidation) {
            if (file.size / 1024 < 200 || file.size / 1024 / 1024 > 25) {
                toast.error(`Greater than 200KB or less than 25MB image are allowed`);
                return;
            }
        }
        helpers.setValue({ url: '', key: '', new: true, loading: true });
        const result = await userUploadFileRequest({ file });
        if (result.error === false) {
            const [resultFile] = result.files;
            const { path, key } = resultFile;
            helpers.setValue({
                url: `${process.env.REACT_APP_AWS_BASE_PATH}/${path}`,
                key,
                new: true,
                loading: false
            });
        }
        // helpers.setValue(file);
    };

    const handleClear = () => {
        console.log('clearing value');
        helpers.setValue({
            url: ``,
            key: '',
            new: true,
            loading: false
        });
    };

    return (
        <FormGroup
            sx={{
                pl: 0.5
            }}
        >
            <label htmlFor={label}>{label}</label>
            {value && value.url ? (
                <Box
                    sx={{
                        ...boxStyles,
                        position: 'relative',
                        cursor: 'default'
                    }}
                >
                    {fileType === 'image' && (
                        <img
                            src={value.url}
                            alt=""
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                        />
                    )}

                    {fileType === 'image' || (
                        <a href={value.url} target="_blank" rel="noreferrer">
                            {fileIcon ? (
                                <InsertDriveFile fontSize="large" color="primary" />
                            ) : (
                                <DocumentIcon fontSize="large" color="primary" />
                            )}
                        </a>
                    )}

                    <DeleteIcon
                        color="error"
                        style={{
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            cursor: 'pointer'
                        }}
                        onClick={handleClear}
                    />
                </Box>
            ) : (
                <Box
                    sx={{
                        ...boxStyles
                    }}
                    onClick={() => {
                        fileInputRef.current.click();
                    }}
                >
                    {value?.loading ? <CircularProgress /> : <AddIcon height={100} width={100} />}
                </Box>
            )}

            {value?.url ? null : (
                <input
                    style={{
                        display: 'none'
                    }}
                    ref={fileInputRef}
                    id={label}
                    type="file"
                    {...field}
                    {...props}
                    onChange={handleChange}
                    onClick={(event) => {
                        event.target.value = null;
                    }}
                />
            )}

            <Typography variant="caption">{meta.touched && !!meta.error ? meta.error : '  '} &nbsp;</Typography>
        </FormGroup>
    );
}

export default SingleFileUploadField;
